import axios from "axios";
import { GET_ORGS, ORGS_LOADING } from "./types";
import { returnErrors } from "./errorActions";
import { tokenConfig } from "./authActions";

export const getOrgs = () => (dispatch, getState) => {
  dispatch(setOrgsLoading());
  axios
    .get(`api/orgs`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_ORGS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const setOrgsLoading = () => {
  return {
    type: ORGS_LOADING
  };
};
